module.exports = __webpack_public_path__ + "static/media/papercurve-logo-colour.7244d18c.svg";